// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3acOn","file":"styles_file__itfNT"};